/**
 * Simple tabs
 */
;(function tabs($){

  $(document).ready(init);

  var CONTAINER_SEL = '.Tabs';
  var BTN_CLASS = 'Tabs-link';
  var BTN_ACTIVE_CLASS = 'Tabs-link--active';
  var TAB_SEL = '.Section--tab1, .Section--tab2, .Section--tab3';

  function init(){
    $(CONTAINER_SEL).attr('tabindex', '-1');
    $('.'+BTN_CLASS).on('click', showTab);
  }

  function showTab(event) {
    var link = $(event.currentTarget);
    var selector = link.attr('href').trim();
    if (selector.indexOf('#') !== 0) {
      return;
    }

    // If it’s an internal link, work with that
    event.preventDefault();
    var tab = $(selector);
    if (tab.length !== 1) {
      return;
    }

    // Find elements to unselect or work with
    var otherLink = $('.'+BTN_CLASS).not(link);
    var otherTab = $(TAB_SEL).not(tab);
    var parent = link.parents(CONTAINER_SEL);

    // Update everything
    otherTab.attr('aria-hidden', 'true');
    otherLink.removeClass(BTN_ACTIVE_CLASS);
    tab.attr('aria-hidden', 'false');
    link.addClass(BTN_ACTIVE_CLASS);
    // Put focus back on link container, to avoid halos
    parent.focus();
  }

})(jQuery);